import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const LabeledText = ({ label, value }: { label: string, value: string }) => (
  <View style={styles.container}>
    <Text>
      <Text style={styles.title}>{label}: </Text>
      {value}
    </Text>
  </View>
);

const styles = StyleSheet.create({
  container: {
    marginBottom: 8,
  },
  title: {
    fontWeight: 'bold',
  },
});

export default LabeledText;
